import { useEffect, useState } from "react";
import { api, asArray } from "@/lib/api";
import { StatusBadge, KPI } from "@/components/Primitives";

export default function Backups() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/backups").then(r => setItems(asArray(r.data))); }, []);
  const ok = items.filter(b=>b.status==="success").length;
  const failed = items.filter(b=>b.status==="failed").length;
  const warn = items.filter(b=>b.status==="warning").length;
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Backup Governance</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Backup Jobs</h1>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <KPI label="Success" value={ok} tone="good" testid="bkp-success"/>
        <KPI label="Warning" value={warn} tone="warn" testid="bkp-warn"/>
        <KPI label="Failed" value={failed} tone="bad" testid="bkp-failed"/>
        <KPI label="Success Rate" value={`${Math.round((ok/Math.max(items.length,1))*100)}%`} tone="good" testid="bkp-rate"/>
      </div>
      <div className="bg-zinc-950 border border-zinc-900 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/50 text-[10px] uppercase tracking-widest text-zinc-500 font-mono"><tr><th className="text-left px-4 py-3">Job</th><th className="text-left px-4 py-3">Asset</th><th className="text-left px-4 py-3">Size</th><th className="text-left px-4 py-3">Duration</th><th className="text-left px-4 py-3">Status</th><th className="text-left px-4 py-3">Next Run</th></tr></thead>
          <tbody>
            {items.slice(0,200).map(b => (
              <tr key={b.id} className="border-b border-zinc-900 hover:bg-zinc-900/40">
                <td className="px-4 py-2">{b.job_name}</td>
                <td className="px-4 py-2 font-mono text-xs text-zinc-500">{b.asset_id}</td>
                <td className="px-4 py-2 font-mono">{b.size_gb} GB</td>
                <td className="px-4 py-2 font-mono">{b.duration_min}m</td>
                <td className="px-4 py-2"><StatusBadge status={b.status}/></td>
                <td className="px-4 py-2 font-mono text-xs">{b.next_run?.slice(0,16).replace("T"," ")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
